module.exports = __webpack_public_path__ + "static/media/maxresdefault.6176b55a.png";